import NavForm from "../nav-form";
import ChatText from "../text/chat-text";
import Text from "../text/text";
import { useTranslation } from "react-i18next";
import ImageButton from "../button/image-button";
import { HomeVoice } from "../home/home-voice";
import useMdBreakpoint from "../../hooks/useMdBreakpoint";
import { useAppStore } from "../../store/appStore";
import { CHAT_TYPE } from "@/types/navigation-mode";

interface ChatPanelProps {
  onChatClose: () => void;
  chatType: string;
}

const ChatPanel: React.FC<ChatPanelProps> = ({ onChatClose, chatType }) => {
  const isVoiceChatMode = useAppStore((state) => state.isVoiceChatMode);
  const setVoiceChatMode = useAppStore((state) => state.setVoiceChatMode);

  const { t } = useTranslation();
  const isMd = useMdBreakpoint();

  const getPlaceholder = () => {
    if (chatType == CHAT_TYPE.SIMULATION) {
      return "simulation_placeholder";
    }
    return "chat_placeholder";
  };

  const inputMode = () => {
    return (
      <>
        <div className="hidden p-[20px] md:block">
          <ChatText
            fromChatBot={true}
            text={t("chatbot_default")}
            useTypeWriter={true}
          />
        </div>
        <NavForm
          fromChat={true}
          placeholder={getPlaceholder()}
          onSubmit={() => onChatClose()}
          chatType={chatType}
        />
        <div className="btn-voice-mobile-chat">
          <ImageButton
            onClick={() => {
              setVoiceChatMode(true);
            }}
            src="/assets/icon_mic_on.png"
            alt="microphone icon"
            className="block mx-auto mt-[16px]"
            size={38}
          />
        </div>
      </>
    );
  };

  const voiceMode = () => {
    return (
      <>
        <HomeVoice
          bottomPanel={true}
          onClose={() => {
            onChatClose();
            setVoiceChatMode(false);
          }}
        />
      </>
    );
  };

  const returnButton = () => {
    return (
      <div className="md:hidden inline-flex items-center">
        <ImageButton
          onClick={() => {
            onChatClose();
            setVoiceChatMode(false);
          }}
          src="/assets/icon_return.png"
          alt="thumbnail"
          size={38}
        />
      </div>
    );
  };

  const header = () => {
    return (
      <div className="hidden md:flex md:justify-between items-start">
        <Text text="chatbot" />
        <ImageButton
          onClick={() => {
            onChatClose();
            setVoiceChatMode(false);
          }}
          src="/assets/icon_close.png"
          alt="close button"
          size={22}
        />
      </div>
    );
  };

  return (
    <div className="relative">
      <div className="gradient-border-outer">
        <div
          className={`gradient-border bg-chatpanel rounded-lg md:h-[374px] flex p-[12px] pt-[20px] z-50 ${
            isVoiceChatMode ? "justify-between md:flex-col h-40" : "grid"
          }`}
        >
          {header()}
          {!isVoiceChatMode && !isMd && returnButton()}
          {isVoiceChatMode ? voiceMode() : inputMode()}
        </div>
      </div>
    </div>
  );
};

export default ChatPanel;
